import request from '@/utils/request'

const prefix = '/django_rest/job'

export default {
  getJobReferralInfo (jobId, params) {
    return request.get(`${prefix}/${jobId}/referral/`, { params })
  },
  saveDraftJobReferral (jobId, referralInfo) {
    return request.post(`${prefix}/${jobId}/referral/`, referralInfo)
  },
  submitJobReferral (jobId, referralInfo) {
    return request.put(`${prefix}/${jobId}/referral/`, referralInfo)
  }
}
